<template>
  <div style="display:flex; flex-direction:column;">
    <v-card class="mx-3 overflow-auto" :class="cardClass()" flat>
      <v-layout column>
        <v-card-text id="terms-text" class="pa-2">
          <mrx-translation class="pb-2" :renderAsHTML="true" :token="`app.${panelName}.text`"></mrx-translation>
          <a :href="link" style="color: var(--info)">
            <mrx-translation :token="`app.${panelName}.link`"></mrx-translation>
          </a>
        </v-card-text>
      </v-layout>
      <v-card-actions>
        <v-btn block depressed @click="agree()" id="agree-button" :disabled="agreed">
          <mrx-translation :token="'app.dialog.button.agree'"></mrx-translation>
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import ui from '@/mixins/ui'

  export default {
    name: 'terms',
    mixins: [ ui ],
    model: {
      prop: 'items',
      event: 'click'
    },
    data() {
      return {
        offsetTop: 0
      }
    },
    props: {
      'options': Object,
      'items': Array,
      'panelName': String,
      'agreeProgressesPanel': {
        type: Boolean,
        default: true,
      }
    },
    computed: {
      agreed() {
        return this.items[0].selected
      },
      link() {
        return `legal/${this.$store.state.v4.language.selected}/${this.panelName}.html`
      }
    },
    methods: {
      agree() {
        this.items[0].selected = true;

        if (this.agreeProgressesPanel) {
          this.next();
        }
      },
      onScroll(e) {
        this.offsetTop = e.target.scrollTop
      },
      ...mapActions({ previous: 'v4/navigate/previous', next: 'v4/navigate/next' })
    }
  }
</script>

<style scoped>
  .text-box-wrapper {}

  .text-box {
    max-width: 95%;
    max-height: 300px;
    padding: 20px;
    margin: 10px;
    background-color: white !important;
  }

  .agree-btn {
    width: 7.5rem;
  }

  #message {
    padding: 20px;
  }
</style>
